import React, {useEffect} from 'react';
import Nav from '../components/Nav';
import {useLocation} from "react-router-dom";
import About from '../components/About';
import Services from '../components/Services';
import Work from '../components/Work';
import Contact from '../components/Contact';
import Banner from "../components/Banner";



const Home = () => {

    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
  


    return (
        <div>
            <Banner/>
            <Nav />
            <About />
            <Services />
            <Work />
            <Contact />
        </div>
    )
}

export default Home
